const documentsStorageKeys = [
  'cloudinary.cloudinary',
  'cloudinary.imageUpload',
  'lease.documents',
  'client.documents',
  'property.documents',
];

export function cleanStorage() {
  documentsStorageKeys.forEach((storageKey) => {
    try {
      localStorage.removeItem(storageKey);
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error(error);
    }
  });
}
